import React from 'react';
import MUIDataTable from 'mui-datatables';
import {MuiThemeProvider} from '@material-ui/core/styles';
import {createTheme} from '@mui/material';

class BillingStatements extends React.Component {
    constructor() {
        super();
        this.handleDownload = this.handleDownload.bind(this);
        this.state = {
            data: [],
            loading: true,
            token: null,
        };
    }

    getMuiTheme = () =>
        createTheme({
            overrides: {
                MUIDataTableBodyCell: {
                    root: {
                        backgroundColor: '#FF0000',
                    },
                    cellStackedSmall: {
                        color: '#df6626',
                        fontWeight: '600',
                    },
                },
                MuiPaper: {root: {width: '50%', left: '50%'}},
                MUIDataTableHeadCell: {
                    toolButton: {justifyContent: 'center'},
                    sortActive: {color: '#df6626'},
                    sortAction: {alignItems: 'center'},
                },
            },
        });

    handleDownload = (e, link) => {
        e.preventDefault();

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/octet-stream;',
                'Content-Type': 'application/download',
                Authorization: 'Bearer ' + this.state.token,
            },
        };

        fetch(`./wp-json/asd/api/billing/${link}`, requestOptions)
            .then(response => {
                if (response.ok) {
                  return response.blob()
                }

                const error = `Download failed: ${response.status}`;
                console.log(error);
                throw new Error(error);
            })
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');

                anchor.href = url;
                anchor.download = link;
                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);
            })
            .catch(error => {
                this.setState({data: [], loading: false});
                console.log(error);
            });
    };

    getBillingStatements() {
        const getToken = localStorage.getItem('token');

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + getToken,
            },
        };

        fetch(`./wp-json/asd/api/billing/get`, requestOptions)
            .then(response => {
                if (response.ok) {
                    return response.json();
                }

                const errorMessage = `Error: ${response.statusText}`;
                console.log(errorMessage);
                return { data: []};
            })
            .then(responseData => {
                this.setState({
                    data: responseData.data,
                    loading: false,
                    token: getToken,
                });
            })
            .catch(error => {
                this.setState({data: [], loading: false, token: getToken});
                console.log(error);
            });
    }

    componentDidMount() {
        const selectedTabNum = 4;

        if (selectedTabNum === this.props.SelectedTab) {
            this.getBillingStatements();
        }
    }
    render() {
        const rows =
            (this.state.data)
                ? this.state.data.map(obj => {
                      return {
                          date: obj.date,
                          month_year: obj.month_year,
                          amount: obj.amount,
                          link: [
                              <a
                                  href=""
                                  onClick={e => {
                                      this.handleDownload(e, obj.link);
                                  }}
                              >
                                  DOWNLOAD
                              </a>,
                          ],
                      };
                  })
                : [];

        const columns = [
            {
                label: 'Date',
                name: 'date',
                options: {
                    sort: true,
                    filter: false,
                    sortDirection: 'desc',
                },
            },
            {
                label: 'Billing Statements For',
                name: 'month_year',
                options: {
                    filter: true,
                },
            },
            {
                label: 'Amount',
                name: 'amount',
                options: {
                    sort: true,
                    filter: true,
                },
            },
            {
                label: 'Link',
                name: 'link',
                options: {
                    sort: false,
                    filter: false,
                },
            },
        ];

        const options = {
            filterType: 'dropdown',
            selectableRows: 'none',
            selectableRowsOnClick: false,
            print: false,
            download: false,
            viewColumns: false,
            search: false,
            rowsPerPage: 5,
            rowsPerPageOptions: [5, 10, 20, 30, 50, 100, 150, 200],
            responsive: 'scrollMaxHeight',
            textLabels: {},
        };

        return (
            <div className="w-full sm:w-1/1 w-1/6 mr-3 mb-3 p-6 bg-white border rounded shadow h-full domain-list-wrap w-full pr-6 mt-6">
                <div className="domain-list-table">
                    <div className="tags-title">Billing Statements</div>
                    {this.state.loading ? (
                        <div className="list-download-loader">
                            <div className="spinner"></div>
                        </div>
                    ) : (
                        <MuiThemeProvider theme={this.getMuiTheme()}>
                            <MUIDataTable data={rows} columns={columns} options={options} />
                        </MuiThemeProvider>
                    )}
                </div>
            </div>
        );
    }
}

export default BillingStatements;
